<section class="container-fluid p-2">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-12">
      <div
        class="pb-3 mb-3 d-flex flex-lg-row flex-column gap-2 align-items-lg-center justify-content-between">
        <div>
          <h4 class="mb-0 fw-600 title-color">Order Details</h4>
        </div>
        <div class="d-flex align-items-center">
          <!-- TODO -->
<!--          <a class="me-5 text-body">-->
<!--            <img src="assets/svg/export.svg" class="me-2">-->
<!--            Export-->
<!--          </a>-->
        </div>
      </div>
    </div>
  </div>

  <div class="mb-4">
    <div class="card rounded-3 br-30px">
      <div class="card-body">
        <div class="row align-items-center mb-3">
          <div class="col-lg-6 col-md-6 col-12">
            <p class="text-muted mb-0">Order date: {{ order?.createdAt | date:'dd MMM, yyyy hh:mm a':'UTC+4' }}</p>
          </div>
          <div class="col-lg-6 col-md-6 col-12 text-md-end">
            <p class="mb-0">Status:
              <span class="badge mx-1" [ngClass]="{
            'select-paid': order?.orderStatus === OrderStatus.PAID,
            'select-canceled': order?.orderStatus === OrderStatus.CANCELLED,
            'select-in-delivery': order?.orderStatus === OrderStatus.IN_DELIVERY,
            'select-delivered': order?.orderStatus === OrderStatus.DELIVERED,
            'select-unpaid': order?.orderStatus === OrderStatus.UNPAID,
            'select-new': order?.orderStatus === OrderStatus.NEW
          }">{{ order?.orderStatus }}</span>
            </p>

          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-lg-4 col-md-4 col-12 mb-3">
            <h6><strong>Customer</strong></h6>
            <div class="d-flex align-items-center">

              <img
                [src]="order?.userInfo?.profilePic ? userService.getImage(order.userInfo.profilePic) : 'assets/svg/defaultUserIcon.svg'"
                alt="Customer" class="rounded-circle me-3 width-50px height-50px">
              <div>
                <p class="mb-0">{{ order?.userInfo?.name + ' ' + order?.userInfo?.surname }}</p>
                <p class="mb-0 text-muted">{{ order?.userInfo?.email }}</p>
                <p class="mb-0 text-muted">{{ order?.userInfo?.phoneNumber }}</p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12 mb-3">
            <h6><strong>Shipping address</strong></h6>
            @if (order?.shippingMethod?.type === ShippingType.PICKUP) {
              <p class="mb-0 text-muted"><strong>{{ getShippingMethodName() }}</strong></p>
            } @else if (order?.shippingAddress) {
              <p class="mb-0 text-muted">{{ order?.shippingAddress?.countryRegion }}</p>
              <p class="mb-0 text-muted">{{ order?.shippingAddress?.city }}</p>
              <p
                class="mb-0 text-muted">{{ order?.shippingAddress?.address + ' ' + order?.shippingAddress?.apartmentSuite }}</p>
              <p class="mb-0 text-muted">{{ order?.shippingAddress?.postalCode }}</p>
            } @else {
              <p class="mb-0 text-muted">-</p>
            }
          </div>
          <div class="col-lg-4 col-md-4 col-12 mb-3">
            <h6><strong>Payment details</strong></h6>
            <p class="mb-0 text-muted"><strong>Transaction ID:</strong> xxxxxxx</p>
            <!-- TODO when payment will be ready-->
            <p class="mb-0 text-muted"><strong>Payment method:</strong> Credit card or Idram</p>
            <!-- TODO when payment will be ready-->
            <p class="mb-0 text-muted"><strong>Paid by:</strong> Test Testyan</p><!-- TODO when payment will be ready-->
            <p class="mb-0 text-muted"><strong>Total Amount Paid:</strong> 10,000 AMD</p>
            <!-- TODO when payment will be ready-->
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-5">

    <div class="col-lg-12 col-md-12 col-12">
      <div class="card rounded-3 br-30px">
        <div class="p-4">
          <div class="tab-content">
            <div class="tab-pane fade show active" role="tabpanel" aria-labelledby="all-orders-tab">
              <div class="table-responsive">
                <table class="table mb-0 text-nowrap table-hover table-centered table-with-checkbox">
                  <thead class="table-light">
                  <tr>
                    <th>#</th>
                    <th>Product</th>
                    <th>Color</th>
                    <th>Qty</th>
                    <th>Total (AMD)</th>
                  </tr>
                  </thead>
                  <tbody>
                    @if (order?.shoppingCart?.items != undefined) {
                      @for (item of order.shoppingCart.items; track $index) {
                        <tr>
                          <td class="text-align">
                            <span class="fw-semibold">{{ $index + 1 }}</span>
                          </td>
                          <td class="text-align">
                            <img [src]="item.product.mainImageSafeUrl"
                                 alt="productImage" class="rounded-circle me-3 product-image">
                            {{ item.finalProduct.productName }}
                          </td>
                          <td class="text-align">
                            @if (item.attributeValues.length > 0) {
                              <div
                                [style.background-color]="item.attributeValues[0].value"
                                class="color-box">
                              </div>
                            }
                          </td>
                          <td class="text-align">{{ item.quantity }}</td>
                          <td class="text-align">{{ item.finalProduct.price * item.quantity }}</td>
                        </tr>
                      }
                    }
                  </tbody>
                </table>
              </div>
              <div class="mt-4">
                <div class="row">
                  <div class="col-lg-8 col-md-6 col-12"></div>
                  <div class="col-lg-4 col-md-6 col-12">
                    <ul class="list-unstyled">
                      <li class="d-flex justify-content-between">
                        <span><strong>Subtotal:</strong></span>
                        <span class="text-muted">{{ calculateSubtotal() + ' AMD' }}</span>
                      </li>
                      <li class="d-flex justify-content-between">
                        <span><strong>Shipping charge ({{ getShippingMethodName() }}
                          ):</strong></span>
                        <span
                          class="text-muted">
                          {{ getShippingChargeText() }}
                        </span>
                      </li>
                      <li class="d-flex justify-content-between">
                        <strong>Promo code ({{ order?.promoCode }}):</strong>
                        <span
                          class="text-muted">{{ order?.promoCodeDiscount == null ? '0%' : order.promoCodeDiscount + '%' }}</span>
                      </li>
                      <li class="d-flex justify-content-between">
                        <strong>Paid by customer:</strong>
                        <span class="text-muted">{{ order?.totalAmount }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

